import React from "react";
import "./groupsession.css";
import image_1 from "../../../Assets/Images/gruop-1.png"; // Adjust path as needed
import image_2 from "../../../Assets/Images/gruop-2.png"; // Adjust path as needed
import image_3 from "../../../Assets/Images/gruop-3.png"; // Adjust path as needed
import image_4 from "../../../Assets/Images/gruop-4.png"; // Adjust path as needed
import image_5 from "../../../Assets/Images/gruop-5.png"; // Adjust path as needed
import image_6 from "../../../Assets/Images/gruop-6.png"; // Adjust path as needed

const SessionCard = () => {
  const sessions = [
    {
      name: "Peer Learning",
      desc: "Participants can learn from each other's questions, perspectives, and experiences, which can provide additional insights and understanding.",
      image: image_1,
    },
    {
      name: "Motivation & Accountability",
      desc: "Being part of a group can boost motivation and commitment as participants encourage each other to stay on track.",
      image: image_2,
    },
    {
      name: "Cost Effective",
      desc: "Group sessions are usually less expensive per person compared to one-on-one sessions, making them more accessible.",
      image: image_3,
    },
    {
      name: "Social Interaction",
      desc: "Enhances social skills and provides opportunities for networking, collaboration, and forming friendships.",
      image: image_4,
    },
    {
      name: "Diverse Perspective",
      desc: "Exposure to a variety of viewpoints and problem-solving approaches can enhance creativity and critical thinking.",
      image: image_5,
    },
    {
      name: "Team Dynamics",
      desc: "In sports or collaborative projects, group sessions can improve teamwork, communication, and collective problem-solving skills.",
      image: image_6,
    }
  ];

  return (
    <div className="session-card-container">
      <h2 className="session-card-heading black-text-clip">Group Sessions</h2>
      <div className="session-card-grid">
        {sessions.map((session, index) => (
          <div
            key={index}
            className="session-card-item image-card"
            role="article"
            aria-label={session.name}
          >
            <img
              src={session.image}
              alt={session.name}
              className="session-card-image"
            />
            <div className="text-wrapper">
              <p className="session-card-name">{session.name}</p>
              <p className="hover-text">{session.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SessionCard;
